import { ButtonColorSet, WidgetColors, WidgetStyle } from '../models/reader-document';

export function resolveWidgetStyleColors(
  widgetStyle: WidgetStyle | undefined,
  isDark: boolean,
): WidgetColors {
  if (!widgetStyle) {
    return {};
  }

  if (isDark) {
    return {
      ...(widgetStyle.lightColors ?? {}),
      ...(widgetStyle.darkColors ?? {}),
    };
  }

  return widgetStyle.lightColors ?? {};
}

export function resolveButtonColorSet(
  lightColors: ButtonColorSet | undefined,
  darkColors: ButtonColorSet | undefined,
  isDark: boolean,
): ButtonColorSet {
  if (!isDark) {
    return lightColors ?? {};
  }

  return {
    ...(lightColors ?? {}),
    ...(darkColors ?? {}),
  };
}
